export function isRepeatEnabled(): boolean {
  return import.meta.env.VITE_REPEAT_ENABLED === 'true';
}

export function isRepeatPreviewExperienceEnabled(): boolean {
  return (
    isRepeatEnabled() && import.meta.env.VITE_VERCEL_ENV === 'preview'
  );
}

export const REPEAT_HOME_PATH = '/repeat?view=home';
